import React from 'react'
import { useEffectOnce } from 'react-use'
import { InferGetServerSidePropsType } from 'next'
import { BuilderComponent } from '@builder.io/react'

import { getServerSideProps } from 'src/pages/builder/server'
import LandingsHeader from 'src/pages/builder/LandingHeader'
import Footer from 'client/components/Footer'
import { LandingsContainer } from 'src/pages/builder/styles'
import { dataLayerPush } from 'client/contexts/Tracking'
import { useRouter } from 'next/router'

import { registerBuilderComponents } from 'src/pages/builder/builderUtils'
import { SearchProvider } from 'src/context/search'
import Page from 'src/comps/Page'
import { TopDestinationsProvider } from 'src/context/topDestinations'

registerBuilderComponents()

const pagePathView = '/landings/[...path]'

export { pagePathView }

type Props = InferGetServerSidePropsType<typeof getServerSideProps>

const pageId = 'landings'

export default (props: Props) => {
  const { config, builderContent, topDestinationsJSON } = props
  const { query } = useRouter()

  useEffectOnce(() => {
    dataLayerPush([
      {
        eventName: 'update_utm_values',
        sfl: {
          utm_campaign: query.utm_campaign,
          utm_source: query.utm_source,
          utm_medium: query.utm_medium,
          utm_content: query.utm_content,
        },
      },
    ])
  })

  return (
    <Page config={config} pageId={pageId}>
      <SearchProvider location={null}>
        <TopDestinationsProvider value={{ topDestinationsJSON }}>
          <LandingsHeader />
          <LandingsContainer>
            <BuilderComponent locale={config.locale} model="page" content={builderContent} />
            <Footer />
          </LandingsContainer>
        </TopDestinationsProvider>
      </SearchProvider>
    </Page>
  )
}

export { getServerSideProps }
